/**
 * Guest-only auth routes: logged-in users must not land here (including browser Back).
 */

import { isEnterpriseIdentitySession } from '@/lib/auth'
import { resolvePostLoginRedirectOrDashboardAsync } from '@/lib/postLoginRedirect'

const GUEST_AUTH_PATHS = new Set(['/signin', '/login', '/enterprise-auth'])

export function isGuestAuthPath(pathname: string): boolean {
  const path = pathname.split('?')[0]?.split('#')[0] ?? ''
  if (GUEST_AUTH_PATHS.has(path)) return true
  if (path === '/enterprise/') return true
  return false
}

/** Where to send an authenticated user who hit a guest auth route. */
export async function resolveAuthenticatedAwayFromGuestPath(
  pathname: string,
): Promise<string> {
  const path = pathname.split('?')[0]?.split('#')[0] ?? ''
  if (isEnterpriseIdentitySession()) {
    return '/enterprise/dashboard'
  }
  // Consumer session on enterprise sign-in → app, not enterprise dashboard.
  return resolvePostLoginRedirectOrDashboardAsync()
}
